<h1 mat-dialog-title>
  {{ 'AS_BUILT_CHECKS.TITLE' | translate }}
</h1>

<div mat-dialog-content class="flex-1 flex-layout-column">
  <form class="flex-layout-column flex-gap-20px" [formGroup]="form">
    <warning-checks-form-row
      [inputLabel]="'AS_BUILT_CHECKS.OVERBREAK_CHECK_THRESHOLD' | translate"
      [helperText]="
        'AS_BUILT_CHECKS.OVERBREAK_CHECK_HELPER'
          | translate
            : { value: form.controls.overBreakCheck.value.checkValue ?? 'N/A' }
      "
      [parentFormGroup]="form?.controls?.overBreakCheck"
      [minValue]="0"
      [maxValue]="100"
    ></warning-checks-form-row>

    <warning-checks-form-row
      [inputLabel]="
        'AS_BUILT_CHECKS.DEPTH_COMPARISON_CHECK_THRESHOLD' | translate
      "
      [helperText]="
        'AS_BUILT_CHECKS.DEPTH_COMPARISON_CHECK_HELPER'
          | translate
            : {
                value:
                  form.controls.depthComparisonCheck.value.checkValue ?? 'N/A',
              }
      "
      [parentFormGroup]="form?.controls?.depthComparisonCheck"
      [minValue]="0"
      [maxValue]="100"
    ></warning-checks-form-row>

    <warning-checks-form-row
      [inputLabel]="'AS_BUILT_CHECKS.DEPTH_CHECK_THRESHOLD' | translate"
      [helperText]="
        'AS_BUILT_CHECKS.DEPTH_CHECK_HELPER'
          | translate
            : { value: form.controls.depthCheck.value.checkValue ?? 'N/A' }
      "
      [parentFormGroup]="form?.controls?.depthCheck"
    ></warning-checks-form-row>

    <mat-slide-toggle
      class="flex-1 flex-align-end--center"
      formControlName="diameterCheckEnable"
      color="primary"
      labelPosition="before"
    >
      <div class="flex flex-wrap">
        <span>
          {{ 'AS_BUILT_CHECKS.DIAMETER_CHECK' | translate }}
        </span>

        <zl-helper
          matSuffix
          [popoverText]="'AS_BUILT_CHECKS.DIAMETER_CHECK_HELPER' | translate"
          [options]="options"
        ></zl-helper>
      </div>
    </mat-slide-toggle>
  </form>
</div>

<mat-dialog-actions align="end">
  <button
    mat-raised-button
    color="accent"
    type="button"
    (click)="closeEvent.emit()"
  >
    {{ 'GENERAL.CANCEL' | translate }}
  </button>
  @if (data.id != null) {
    <button mat-raised-button color="warn" (click)="resetEvent.emit(data)">
      {{ 'GENERAL.RESET' | translate }}
    </button>
  }
  <button
    mat-raised-button
    color="primary"
    (click)="onSave()"
    [ngClass]="{ disabled: !this.form.valid }"
    [disabled]="!this.form.valid"
  >
    {{ 'GENERAL.SAVE' | translate }}
  </button>
</mat-dialog-actions>
